/** Public blog + admin blog CRUD. */
import client from './client';

export const blogAPI = {
  // Public
  listPosts: async ({ page = 1, limit = 12, tag = '', search = '' } = {}) => {
    const q = new URLSearchParams();
    q.append('page', String(page));
    q.append('limit', String(limit));
    if (tag) q.append('tag', tag);
    if (search) q.append('search', search);
    return (await client.get(`/blog/posts?${q.toString()}`)).data;
  },
  getPost: async (slug) => (await client.get(`/blog/posts/${slug}`)).data,

  // Admin
  adminList: async ({ page = 1, limit = 20, status = '', search = '' } = {}) => {
    const q = new URLSearchParams();
    q.append('page', String(page));
    q.append('limit', String(limit));
    if (status) q.append('status', status);
    if (search) q.append('search', search);
    return (await client.get(`/admin/blog/posts?${q.toString()}`)).data;
  },
  adminGet: async (id) => (await client.get(`/admin/blog/posts/${id}`)).data,
  adminCreate: async (payload) => (await client.post('/admin/blog/posts', payload)).data,
  adminUpdate: async (id, payload) => (await client.put(`/admin/blog/posts/${id}`, payload)).data,
  adminDelete: async (id) => (await client.delete(`/admin/blog/posts/${id}`)).data,
  adminUploadMedia: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return (await client.post('/admin/blog/media', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })).data;
  },
};

export default blogAPI;
